import {
  mapToneToLabel,
  mapPersonalityToLabel,
} from '../constants/VelarisAiConstants';

export const hasSettingsChanged = (
  settings,
  originalTone,
  originalPersonalities
) => {
  const toneChanged = settings?.selectedTone !== originalTone;
  const personalitiesChanged =
    settings?.selectedPersonalities.sort().join(',') !==
    originalPersonalities.sort().join(',');
  return toneChanged || personalitiesChanged;
};

export const removeAttributeFromArray = (arrayOfObjects, attributeName) => {
  arrayOfObjects.forEach((obj) => {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(attributeName)) {
      delete obj[attributeName];
    }
  });
  return arrayOfObjects;
};

export const constructActionMessage = (
  originalTone,
  settings,
  originalPersonalities
) => {
  const changes = [];

  if (settings?.selectedTone !== originalTone) {
    changes.push(
      mapToneToLabel[settings?.selectedTone] || settings?.selectedTone
    );
  }

  settings?.selectedPersonalities?.forEach((personality) => {
    if (!originalPersonalities.includes(personality)) {
      changes.push(mapPersonalityToLabel[personality] || personality);
    }
  });

  if (changes.length === 1) {
    return `Make it ${changes[0]}`;
  }
  const lastChange = changes.pop();
  return `Make it ${changes.join(', ')} and ${lastChange}`;
};
